import React from "react"
import Card from "react-bootstrap/Card"
import { IEvent } from "../../../../types/event"
import styled from "styled-components"
import { instagram } from "../../../../assets"
import { truncate } from "../../../../helpers/string"

const CardContent = `  
  background: var(--color-light);
  border: none;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;

  p {
    margin: 0;
  }
`

const CardHeader = styled(Card.Header)`
  ${CardContent}

  .icon {
    width: 20px;
  }
`

const CardBody = styled(Card.Body)`
  font-family: var(--font-secondary);
  font-size: var(--font-size-sm);
  padding: 5px 15px;

  .link-item {
    font-family: var(--font-primary);
    color: var(--color-dark);
    margin-left: 5px;
  }
`

const CardFooter = styled(Card.Footer)`
  ${CardContent}

  .type, .date {
    font-family: var(--font-secondary);
    font-size: var(--font-size-sm);
    text-transform: capitalize;
  }
  .date {
    font-style: italic;
  }
`

const CardWrapper = styled(Card)`
  margin-bottom: auto;
`

const CardLink = styled(Card.Link)`
  color: black;

  &:hover {
    text-decoration: underline;
    color: var(--color-green);

    img {
      opacity: 0.7;
    }
  }
`

const CardImg = styled(Card.Img)`
  border-bottom: 1px solid var(--color-light-2);
`

interface IProps {
  item: IEvent
}

const InstaCard = ({ item }: IProps) => {
  return (
    <CardWrapper>
      {item.img && (
        <CardLink href={item.href} target="_blank">
          <CardImg variant="top" src={item.img} />
        </CardLink>
      )}

      <CardHeader>
        <CardLink href={item.href} target="_blank">
          @atelier.georges
        </CardLink>
        <img className="icon" src={instagram} alt="twitter" />
      </CardHeader>

      <CardBody>
        <Card.Text>
          {item.text?.length > 60 ? (
            <>
              <span>{truncate(item.text, 60)}</span>
              {item.href && (
                <a
                  className="link-item"
                  href={item.href}
                  target="_blank"
                >
                  suite
                </a>
              )}
            </>
          ) : (
            item.text
          )}
        </Card.Text>
      </CardBody>

      <CardFooter>
        <Card.Text className="date">{item.dateFormatted}</Card.Text>

        <CardLink href={item.href} target="_blank">
          <Card.Text className="type">{item.type}</Card.Text>
        </CardLink>
      </CardFooter>
    </CardWrapper>
  )
}

export default InstaCard
